module.exports = __webpack_public_path__ + "static/media/inman-logo.620b4088.svg";